// Catálogo central de eventos de telemetría.
// Vive aquí (módulo neutral sin imports de React/sinks) para poder derivar la KEY
// del evento a partir de su display value sin crear ciclos de import.
// `useTracking` re-exporta TRACK_EVENT_NAMES/TRACK_ERROR_NAMES para no romper los
// imports existentes de los componentes.

export const TRACK_EVENT_NAMES = {
  CouponsSearchLoaded: 'Cupones - Resultados de Búsqueda Cargados',
  CouponSearchClicked: 'Cupones - Búsqueda Realizada',
  CouponAddClicked: 'Cupones - Clic en Botón Agregar',
  CouponEditClicked: 'Cupones - Clic en Botón Editar',
  CouponCopyClicked: 'Cupones - Clic en Botón Copiar',
  CouponDeleteClicked: 'Cupones - Clic en Botón Eliminar',
  RegistrationCommerceDataUpdated: 'Registro - Datos del comercio',
  RegistrationContactDataUpdated: 'Registro - Datos del contacto',
  RegistrationAccessDataUserUpdated: 'Registro - Datos de acceso del usuario',
  RegistrationAccessDataPasswordUpdated: 'Registro - Datos de acceso de contraseña',
  RegistrationFormSubmitted: 'Registro - Formulario enviado',
  LocationEditClicked: 'Configuración - Clic en Editar Ubicación',
  LocationSaveClicked: 'Configuración - Clic en Guardar Ubicación',
  LocationSaveError: 'Configuración - Error al Guardar Ubicación',
  IntegrationUnavailableConnectClick: 'Integraciones - Clic en Integracion no disponible',
  MenuOrderPhoneOpened: 'Ordenes - Menu embebido abierto',
  MenuOrderPhoneClosed: 'Ordenes - Menu embebido cerrado',
  MenuOrderPhoneNewOrder: 'Ordenes - Menu embebido pedido recibido',
  ConfigurationMenuThemeSelection: 'Configuracion - Tema de menu seleccionado',
  ConfigurationMenuThemeChangeDenied: 'Configuracion - Tema no disponible para plan',
  BillingModificationRequested: 'Facturación Stripe - Solicitud de modificación',
  GigstackPortalUrlRequested: 'Gigstack - Portal de facturación',
  OnboardingPageLoaded: 'Onboarding - Cargado',
  OnboardingGeneralInfoSaved: 'Onboarding - Información General Guardada',
  OnboardingCommerceAddressSaved: 'Onboarding - Dirección del Comercio Guardada',
  OnboardingSchedulesSaved: 'Onboarding - Horarios Guardados',
  OnboardingDeliveryMethodsSaved: 'Onboarding - Métodos de Entrega Guardados',
  OnboardingFinished: 'Onboarding - Completado',
  // Setup Page Events
  SetupPageLoaded: 'Setup - Página Cargada',
  SetupIntelligentConfigClicked: 'Setup - Clic en Configuración Inteligente',
  SetupAddressClicked: 'Setup - Clic en Dirección del Negocio',
  SetupPaymentMethodsClicked: 'Setup - Clic en Métodos de Entrega y Pago',
  SetupSchedulesClicked: 'Setup - Clic en Horarios de Atención',
  SetupModalOpened: 'Setup - Modal Abierto',
  SetupModalClosed: 'Setup - Modal Cerrado',
  SetupFormSaved: 'Setup - Formulario Guardado',
  CommerceCoverImageUpdated: 'Configuración - Cover de Comercio Actualizado',
  CommerceCoverImageDeleted: 'Configuración - Cover de Comercio Eliminado',
  CommerceCoverImageError: 'Configuración - Error al Actualizar Cover',
  SupportClicked: 'Header - Clic en Soporte en Línea',
  SuggestionsClicked: 'Header - Clic en Sugerencias',
  MenuViewClicked: 'Header - Clic en Ir a mi Menú',
  MyAccountClicked: 'Header - Clic en Mi Cuenta',
  UpdatesClicked: 'Header - Clic en Actualizaciones',
  LogoutClicked: 'Header - Clic en Cerrar Sesión',
  WhatsAppSupportClicked: 'Header - Clic en Soporte WhatsApp',
  // Feedback Flow Events
  FeedbackButtonClicked: 'Feedback - Clic en Ayúdanos a Mejorar',
  FeedbackWarningModalOpened: 'Feedback - Modal Informativo Abierto',
  FeedbackWarningModalClosed: 'Feedback - Modal Informativo Cerrado (Regresar)',
  FeedbackWarningModalContinued: 'Feedback - Modal Informativo Continuado',
  FeedbackFormModalOpened: 'Feedback - Modal de Formulario Abierto',
  FeedbackTemplateClicked: 'Feedback - Plantilla Rápida Seleccionada',
  FeedbackFormCanceled: 'Feedback - Formulario Cancelado',
  FeedbackFormSubmitted: 'Feedback - Mensaje Enviado',
  // Menú V2 — Atajo "Editar precios" (rediseño del listado, ver PR #1052)
  // Permite segmentar adopción del atajo vs entrada al editor completo,
  // qué affordance usan más (desktop button / mobile kebab / price pill),
  // y la salud del flujo (validación que bloquea, errores de backend).
  MenuV2QuickPriceOpened: 'Menú V2 - Editar Precios Abierto',
  MenuV2QuickPriceSaved: 'Menú V2 - Editar Precios Guardado',
  MenuV2QuickPriceBlocked: 'Menú V2 - Editar Precios Bloqueado por Validación',
  MenuV2QuickPriceError: 'Menú V2 - Editar Precios Error de Backend',
  MenuV2QuickPriceCoachmarkDismissed: 'Menú V2 - Coachmark Editar Precios Descartado',
  BulkPriceUpdateClicked: 'Productos - Clic en Actualizar Precios Masivamente',
  BulkPriceUpdatePageLoaded: 'Productos - Página de Actualización Masiva Cargada',
  BulkPriceUpdateConfirmed: 'Productos - Confirmación de Actualización Masiva',
  BulkPriceUpdateExecuted: 'Productos - Actualización Masiva Ejecutada',
  MenuUploaderV1Clicked: 'Productos - Clic en Pdf to Menu (V1)',
  MenuUploaderV2Clicked: 'Productos - Clic en Procesador Inteligente (V2)',
  MenuUploaderV1PageLoaded: 'Menu Uploader - Página V1 Cargada',
  MenuUploaderV2PageLoaded: 'Menu Uploader - Página V2 Cargada',
  // MenuUploaderV2 - Upload Zone Events
  MenuUploaderV2FileSelected: 'Menu Uploader V2 - Archivo Seleccionado',
  MenuUploaderV2FileRemoved: 'Menu Uploader V2 - Archivo Removido',
  MenuUploaderV2AnalysisStarted: 'Menu Uploader V2 - Análisis Iniciado',
  // MenuUploaderV2 - AI Analysis Events
  MenuUploaderV2AnalysisCompleted: 'Menu Uploader V2 - Análisis Completado',
  MenuUploaderV2AnalysisError: 'Menu Uploader V2 - Error en Análisis',
  // MenuUploaderV2 - Element Selection Events
  MenuUploaderV2ElementToggled: 'Menu Uploader V2 - Elemento Seleccionado/Deseleccionado',
  MenuUploaderV2SelectAllClicked: 'Menu Uploader V2 - Seleccionar Todos',
  MenuUploaderV2DeselectAllClicked: 'Menu Uploader V2 - Deseleccionar Todos',
  MenuUploaderV2ChangeFileClicked: 'Menu Uploader V2 - Cambiar Archivo',
  MenuUploaderV2ContinueToEditorClicked: 'Menu Uploader V2 - Continuar a Editor',
  // MenuUploaderV2 - Interactive Editor Events
  MenuUploaderV2TabChanged: 'Menu Uploader V2 - Cambio de Pestaña',
  MenuUploaderV2ElementEdited: 'Menu Uploader V2 - Elemento Editado',
  MenuUploaderV2ElementDuplicated: 'Menu Uploader V2 - Elemento Duplicado',
  MenuUploaderV2ElementDeleted: 'Menu Uploader V2 - Elemento Eliminado',
  MenuUploaderV2ManualElementAdded: 'Menu Uploader V2 - Elemento Agregado Manualmente',
  MenuUploaderV2BackToSelectionClicked: 'Menu Uploader V2 - Volver a Selección',
  MenuUploaderV2ProcessMenuClicked: 'Menu Uploader V2 - Procesar Menú',
  MenuUploaderV2ValidationError: 'Menu Uploader V2 - Error de Validación',
  // MenuUploaderV2 - Processing Events
  MenuUploaderV2ProcessingStarted: 'Menu Uploader V2 - Procesamiento Iniciado',
  MenuUploaderV2CategoryCreated: 'Menu Uploader V2 - Categoría Creada',
  MenuUploaderV2CategoryError: 'Menu Uploader V2 - Error al Crear Categoría',
  MenuUploaderV2ProductCreated: 'Menu Uploader V2 - Producto Creado',
  MenuUploaderV2ProductError: 'Menu Uploader V2 - Error al Crear Producto',
  MenuUploaderV2ExtraCreated: 'Menu Uploader V2 - Extra Creado',
  MenuUploaderV2ExtraError: 'Menu Uploader V2 - Error al Crear Extra',
  MenuUploaderV2ProcessingCompleted: 'Menu Uploader V2 - Procesamiento Completado',
  // MenuUploaderV2 - Dashboard Events
  MenuUploaderV2DashboardViewChanged: 'Menu Uploader V2 - Vista de Dashboard Cambiada',
  MenuUploaderV2ErrorResolved: 'Menu Uploader V2 - Error Resuelto',
  MenuUploaderV2ResolveAllErrorsClicked: 'Menu Uploader V2 - Resolver Todos los Errores',
  MenuUploaderV2SuccessModalShown: 'Menu Uploader V2 - Modal de Éxito Mostrado',
  MenuUploaderV2GoToMenuClicked: 'Menu Uploader V2 - Ir a Menú',
  MenuUploaderV2AutoRedirect: 'Menu Uploader V2 - Redirección Automática',
  // MenuUploaderV2 - Error Recovery Events
  MenuUploaderV2RetryClicked: 'Menu Uploader V2 - Reintentar',
  // ShareMenu — Kit de difusión
  ShareMenuPageLoaded: 'Kit Difusión - Página Cargada',
  ShareMenuLinkCopied: 'Kit Difusión - Link Copiado',
  ShareMenuChannelClicked: 'Kit Difusión - Canal Compartido',
  ShareMenuDownloadClicked: 'Kit Difusión - Descarga Clickeada',
  ShareMenuTemplateChanged: 'Kit Difusión - Plantilla Cambiada',
  ShareMenuCustomizationChanged: 'Kit Difusión - Personalización Cambiada',
  ShareMenuQRGenerated: 'Kit Difusión - QR Generado Exitosamente',
  ShareMenuQRGenerateError: 'Kit Difusión - Error al Generar QR',
  ShareMenuResetClicked: 'Kit Difusión - Clic en Resetear',
  // Video Tutorial Events
  VideoTutorialTooltipClicked: 'Tutorial - Tooltip de Video Mostrado',
  VideoTutorialModalOpened: 'Tutorial - Modal de Video Abierto',
  VideoTutorialPaymentMethodClicked: 'Tutorial - Método de Pago Clickeado',
  VideoTutorialChangePasswordClicked: 'Tutorial - Cambiar Contraseña Clickeado',
  VideoTutorialFacebookPixelClicked: 'Tutorial - Pixel Facebook Clickeado',
  VideoTutorialProductManagementClicked: 'Tutorial - Gestión Productos Clickeado',
  VideoTutorialQRPersonalizedClicked: 'Tutorial - QR Personalizado Clickeado',
  VideoTutorialDeliveryMethodsClicked: 'Tutorial - Métodos Entrega Clickeado',
  VideoTutorialPricingChannelClicked: 'Tutorial - Precios Canal Clickeado',
  VideoTutorialCouponsClicked: 'Tutorial - Cupones Clickeado',
  VideoTutorialSectionsRequiredClicked: 'Tutorial - Secciones Obligatorias Clickeado',
  VideoTutorialSectionsConfigClicked: 'Tutorial - Configurar Secciones Clickeado',
  VideoTutorialIntegrationHelpClicked: 'Tutorial - Ayuda Integración Clickeado',
  BulkPriceUpdateTutorialShown: 'Tutorial - Actualización Masiva de Precios Mostrado',
  OrderTutorialShown: 'Tutorial - Pedidos Mostrado',
  // Promo Modal Events
  PromoModalOpened: 'Promo Modal - Abierto',
  PromoModalClosed: 'Promo Modal - Cerrado',
  PromoModalNewFlowClicked: 'Promo Modal - Nuevo Flujo Seleccionado',
  PromoModalOldFlowClicked: 'Promo Modal - Flujo Actual Seleccionado',
  PromoModalCheckboxToggled: 'Promo Modal - Checkbox Alternado',
  PromoModalDirectNewFlow: 'Promo Modal - Navegación Directa a Nuevo Flujo',
  PromoModalDirectOldFlow: 'Promo Modal - Navegación Directa a Flujo Actual',
  // Social Profile Events
  SocialProfilePageLoaded: 'Perfil Social - Página Cargada',
  SocialProfileSaveSuccess: 'Perfil Social - Guardado Exitoso',
  SocialProfileSaveError: 'Perfil Social - Error al Guardar',
  SocialProfileUrlCopied: 'Perfil Social - URL Copiada',
  // Cook Time / ETA Events (observabilidad del tiempo de preparación comprometido)
  // GA4 deriva el nombre snake_case del KEY: cook_time_configured, order_accepted_with_eta, eta_edited.
  CookTimeConfigured: 'Tiempo de Preparación - Configurado',
  OrderAcceptedWithEta: 'Pedidos - Aceptado con Tiempo Estimado',
  EtaEdited: 'Pedidos - Tiempo Estimado Editado',
  // Feature Rollout Events (framework de versiones por feature — Fase A)
  // GA4 deriva el nombre snake_case del KEY: feature_invitation_shown, feature_switched, etc.
  FeatureInvitationShown: 'Rollout - Invitación Mostrada',
  FeatureInvitationAccepted: 'Rollout - Invitación Aceptada',
  FeatureSwitched: 'Rollout - Versión Cambiada',
  FeatureReverted: 'Rollout - Versión Revertida',
  // Feedback del revert (prompt D1, omitible): adjunta el motivo a la reversión SIN volver a
  // contarla. Evento distinto de FeatureReverted para no inflar el conteo de reversiones.
  FeatureRevertFeedback: 'Rollout - Feedback de Reversión',
  // Anuncio de graduación (GA): banner "nueva funcionalidad" cuando la versión nueva ya es
  // la oficial del comercio (ga_forced). Mostrado/descartado por el merchant.
  FeatureGaAnnouncementShown: 'Rollout - Anuncio GA Mostrado',
  FeatureGaAnnouncementDismissed: 'Rollout - Anuncio GA Descartado',
  // CTA del anuncio (opcional): el merchant tocó la acción primaria del banner (p.ej. "Ver pedidos
  // programados" en el capability_launch de scheduled-orders). Distinto de Descartado: mide INTENCIÓN
  // de usar la funcionalidad, no el cierre-por-defecto. El clic también descarta el banner de forma
  // durable (ya lo enganchó) y, en features de entitlement, dispara la señal de uso del ERP.
  FeatureGaAnnouncementCtaClicked: 'Rollout - Anuncio GA CTA Clic',
  // Smart Menu (PR onboarding-smart-menu-v4) — convención de funnel:
  //  · KEY en inglés → GA4 deriva `smart_menu_*` (agrupa alfabético, ≤40 chars).
  //  · Valor en español con PASO NUMERADO → Clarity/PostHog listan el funnel en
  //    orden cronológico al ordenar alfabéticamente. `x` = rama de error del paso.
  //    Pasos laterales (recuperar/posponer/reiniciar) van sin número.
  SmartMenuViewed: 'Smart Menu - 1 Visto',
  SmartMenuFilesAdded: 'Smart Menu - 2 Archivos',
  SmartMenuProcessStart: 'Smart Menu - 3 Procesar',
  SmartMenuProcessOk: 'Smart Menu - 4 Analizado',
  SmartMenuProcessError: 'Smart Menu - 4x Error Analisis',
  SmartMenuEdit: 'Smart Menu - 5 Edicion',
  SmartMenuAppendFiles: 'Smart Menu - 5 Agregar Archivos',
  SmartMenuPublishStart: 'Smart Menu - 6 Publicar',
  SmartMenuPublishOk: 'Smart Menu - 7 Publicado',
  SmartMenuPublishError: 'Smart Menu - 7x Error Publicar',
  SmartMenuRecover: 'Smart Menu - Recuperado',
  SmartMenuSkipped: 'Smart Menu - Pospuesto',
  SmartMenuRestarted: 'Smart Menu - Reiniciado',
  // Impresión Bluetooth (BLE) — funnel de emparejamiento, reconexión e impresión
  BleCapability: 'Impresión BLE - Capacidad',
  BlePairAttempt: 'Impresión BLE - Emparejar Intento',
  BlePairSuccess: 'Impresión BLE - Emparejar Éxito',
  BlePairCancelled: 'Impresión BLE - Emparejar Cancelado',
  BleReconnectSuccess: 'Impresión BLE - Reconectar Éxito',
  BleReconnectFailed: 'Impresión BLE - Reconectar Fallo',
  BlePrintSuccess: 'Impresión BLE - Impresión Éxito',
  BlePrintFailure: 'Impresión BLE - Impresión Fallo',
  BleMasterToggle: 'Impresión BLE - Modo',
  // Paulina (asistente de soporte/CS — feature agent-chat). Homologados al pipeline canónico
  // (PostHog + Clarity Smart Event + GA4) igual que Smart Menu: ya no usan el track bespoke
  // `pau_*`. La sesión de Paulina se segmenta por estos eventos `Paulina - …`.
  PaulinaChatOpened: 'Paulina - Chat Abierto',
  PaulinaMessageSent: 'Paulina - Mensaje Enviado',
  PaulinaResponseOk: 'Paulina - Respuesta OK',
  PaulinaResponseError: 'Paulina - Respuesta con Error',
  PaulinaToolUsed: 'Paulina - Tool Usada',
  PaulinaChatCleared: 'Paulina - Chat Limpiado',
  PaulinaResponseUseful: 'Paulina - Respuesta Útil',
  PaulinaFeedbackSent: 'Paulina - Feedback Enviado',
  PaulinaDeactivated: 'Paulina - Desactivada',
  PaulinaProactiveShown: 'Paulina - Proactivo Mostrado',
  PaulinaProactiveAccepted: 'Paulina - Proactivo Aceptado',
  PaulinaProactiveDismissed: 'Paulina - Proactivo Descartado',
  PaulinaChipsShown: 'Paulina - Chips Mostrados',
  PaulinaSuggestedChipClicked: 'Paulina - Chip Sugerido Click',
  PaulinaNavigationClicked: 'Paulina - Navegación Click',
  PaulinaInviteShown: 'Paulina - Invitación Mostrada',
  PaulinaInviteAccepted: 'Paulina - Invitación Aceptada',
  PaulinaInviteDismissed: 'Paulina - Invitación Descartada',
  PaulinaRageClick: 'Paulina - Rage Click',
} as const;

export const TRACK_ERROR_NAMES = {
  StatsIframeLoading: 'Error - Iframe Metabase',
};

// Mapa inverso display value → KEY. Permite derivar el nombre snake_case limpio
// (en inglés) para GA4 a partir del texto en español que recibe trackEvent.
export const EVENT_VALUE_TO_KEY: Record<string, string> = Object.fromEntries(
  Object.entries(TRACK_EVENT_NAMES).map(([key, value]) => [value, key]),
);

// Eventos críticos: disparan Clarity.upgrade() para priorizar la grabación de la
// sesión (Clarity samplea a 100k/día). Se listan por KEY.
export const CRITICAL_EVENT_KEYS = new Set<string>([
  'OnboardingFinished',
  'RegistrationFormSubmitted',
  'MenuUploaderV2ProcessingCompleted',
  'BillingModificationRequested',
  'BlePrintFailure',
  'BleReconnectFailed',
  'BlePairCancelled',
  // Smart Menu: errores del funnel + conversión final → priorizar grabación Clarity.
  'SmartMenuProcessError',
  'SmartMenuPublishError',
  'SmartMenuPublishOk',
  // Paulina: priorizar la grabación Clarity de la rama de error (diagnóstico de fallos del agente).
  'PaulinaResponseError',
]);
